import React, { useState, useEffect } from "react";
import MapComponent from "./MapComponent";
import ShopList from "./ShopList";

const shops = [
  {
    name: "Minh Vũ baby",
    address: "47 Phố Chờ, TT. Chờ, Yên Phong, Bắc Ninh",
    location: { lat: 21.194734833397202, lng: 105.95380212410781 },
    province: "Bắc Ninh",
  },
  {
    name: "Bông Kids",
    address: "48 Cầu Trì, Sơn Tây, Hà Nội",
    location: { lat: 21.127415201276918, lng: 105.50210456991753 },
    province: "Hà Nội",
  },
  // Add more shops here
];

const ShopFinder = () => {
  const [selectedShop, setSelectedShop] = useState(null);

  useEffect(() => {
    document.title = "Đại lý Mễ Mễ";
  });
  return (
    <div className="d-flex gap-3 ms-3 me-3">
      <div style={{ width: "40%" }}>
        <ShopList shops={shops} onSelectShop={setSelectedShop} />
      </div>
      <div style={{ width: "60%" }}>
        <MapComponent selectedShop={selectedShop} />
      </div>
    </div>
  );
};

export default ShopFinder;
